import { useEffect } from "react";
import { newID } from "../utils/unique";

export type MessageHandler = (message: any) => void;

// NOTE: always use useCallback() on handler
export function useChannel(name: string, handler: MessageHandler, condition?: boolean) {
 
    useEffect(() => {

        const include = (condition === true || condition === undefined);

        let sub: any;
        if (include) {
            sub = subscribe(name, handler);
        }

        return () => {
            if (sub) {
                unsubscribe(name, sub);
            }
        }

    }, [name, handler, condition]);

}

const channels = {} as any;

function getChannel(name: string) {
    return channels[name];
}

function getOrCreateChannel(name: string) {
    if (!channels[name]) channels[name] = [];
    return channels[name];
}

interface Subscription {
    id: string,
    handler: any,
}

export function subscribe(name: string, handler: MessageHandler) {
    const c = getOrCreateChannel(name);
    const sub = {
        id: newID(),
        handler,
    };
    c.push(sub);
    return sub;
}

export function unsubscribe(name: string, sub: Subscription) {
    const c = getChannel(name);
    if (!c) return;

    const i = c.indexOf(sub);
    if (i >= 0) {
        c.splice(i, 1);
    }

    // subscribers still left here?
    if (c.length <= 0) {
        // no, so tidy
        delete channels[name];
    }
}

export function broadcast(name: string, msg?: any) {
	//console.log(`broadcast: ${name} - ${msg && msg.type ? msg.type : "{}"}`);

    const c = getChannel(name);
    if (!c) return;

    for(let sub of c) {
        if (sub.handler) sub.handler(msg);
		if (msg && msg.cancelled) break;
    }
}




